import React from "react";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import Title from "../../common/widgetTitle/WidgetTitle";
import OrderTable from "../../orders/orderTable/OrderTable";
import box from "../../../images/common/box.svg";
import styles from "./NewOrders.scss";

const NewOrders = (props: Object) => {
  const { data, currencyCode, onAcceptOrder, lang } = props;
  return (
    <div className={styles.ctr}>
      <Title
        title={I18n.getText("dashboard.new-orders", {}, "New Orders")}
        // enableBtn
        // btnText={I18n.getText('dashboard.view-all', {}, 'View All')}
        // btnLink={'/orders'}
      />
      {!_.isEmpty(data) ? (
        <OrderTable
          data={data}
          onAcceptOrder={onAcceptOrder}
          currencyCode={currencyCode}
          orderStatus={1}
          lang={lang}
          linkOrder
        />
      ) : (
        <div className={styles.blank}>
          <img src={box} />
          <p className={styles.blankMain}>
            {I18n.getText("dashboard.no-new-orders")}
          </p>
          <p className={styles.blankSub}>
            {I18n.getText("dashboard.no-new-orders-sb")}
          </p>
        </div>
      )}
    </div>
  );
};

export default NewOrders;



// WEBPACK FOOTER //
// ./src/components/dashboard/newOrders/NewOrders.js